import { CodeMapCategory, CodeMapTokenWithLocate } from 'adminConsole/page'
import { codeMapStore as mobileCodeMapStore } from 'mobileApp/store'
import { codeMapStore as adminCodeMapStore } from 'adminConsole/store'
import { useMemo } from 'react'
import { getCodeMapOptions } from 'share/util/common'

type Option = {
  label: string
  value: string
  disabled?: boolean
}

type CodeMapRadioProps = {
  category: CodeMapCategory
  value: string
  onChange: (value: string) => void
  optionDisabled?: (option: Option) => boolean
  className?: string
  locateAt: CodeMapTokenWithLocate
}

export const CodeMapRadio = ({ category, value, onChange, optionDisabled, className, locateAt }: CodeMapRadioProps) => {
  const codeMapList =
    locateAt === CodeMapTokenWithLocate.Admin ? adminCodeMapStore.codeMapList : mobileCodeMapStore.codeMapList

  const options: Option[] = useMemo(() => {
    const opts = getCodeMapOptions(codeMapList, category, true, '', 'desc')

    return opts.map(o => ({
      ...o,
      disabled: optionDisabled?.(o) ?? false,
    }))
  }, [codeMapList, category, optionDisabled])

  // 如果尚未取得任何 options (載入中或 server 還沒回應)
  if (options.length === 0) return <p>...載入中</p>

  return (
    <div className={`form-group ${className ?? ''}`}>
      {options.map(option => {
        const id = `${category}-${option.value}`
        return (
          <div key={option.value} className="form-check form-check-inline">
            <input
              type="radio"
              id={id}
              name={category}
              value={option.value}
              className="form-check-input"
              checked={value === option.value}
              disabled={option.disabled}
              onChange={() => onChange(option.value)}
            />
            <label htmlFor={id} className="form-check-label">
              {option.label}
            </label>
          </div>
        )
      })}
    </div>
  )
}
